<script setup lang="ts">
import { LIcon } from '@wgg.hyve/hyve-ui-library'

type ErrorMessageBoxProps = {
  message?: string
}

const props = defineProps<ErrorMessageBoxProps>()
</script>

<template>
  <div class="linexo light-theme error-message-box" role="alert">
    <div class="error-message-box__content">
      <LIcon
        class="error-message-box__icon"
        icon="lnx-warning_filled"
        color="warning"
        aria-label="warning"
      />
      <output class="error-message-box__message" :title="props.message" ref="container">
        <span class="error-message-box__scroll" ref="scrollText">
          {{ props.message }}
        </span>
      </output>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'a-error-message-box';
</style>
